<i18n>
{
  "en": {
    "payment_success": "Payment success",
    "payment_fail": "Payment fail",
    "possible_reason": "Reasons could be",
    "fail_reasons": [
        "1. Credit card has not activated yet.",
        "2. Wrong credit card number or expiration date",
        "3. Credit card expiration date exceeded.",
        "4. Insufficient credit line or lack of balance.",
        "5. Credit card issuing bank internal system error.",
        "6. Two or more credit card authorization doing at the same time.",
        "7. Internet disconnection during credit card authorization.",
        " "
    ],
    "how_to_fix": "Please try to purchase again if you have not exceeded your credit card credit line. Please note that you have inserted the correct credit card number, name, expiration date and CVV2/CVC2(AE card, please insert 4 check digit, which is at the front upper right place). If you still can not complete the authorization process, please contact your credit card issuing bank for further assistance.",
    "got_it": "Got it"
  },
  "zhHant": {
    "payment_success": "付款成功",
    "payment_fail": "付款失敗",
    "possible_reason": "可能原因有",
    "fail_reasons": [
        "1. 信用卡第一次使用尚未開卡。",
        "2. 信用卡卡號或到期日輸入錯誤。",
        "3. 信用卡已超過到期日使用期限。",
        "4. 超出信用卡使用額度或餘額不足。",
        "5. 信用卡發卡銀行內部系統問題…等。",
        "6. 此筆卡號同時有人刷卡授權中，因此視窗會跳出。",
        "7. 信用卡授權時，網路斷線。",
        "8. 您已達風險控管條件(credit),故無法繼續操作。"
    ],
    "how_to_fix": "請重新確認是否有誤，或是換另一張卡，然後再試一次。 若仍無法解決問題，請聯絡您的信用卡發行銀行請求協助，謝謝。",
    "got_it": "我知道了"
  },
  "ja":{
    "payment_success": "決済完了",
    "payment_fail": "取引失敗",
    "possible_reason": "考えられる原因",
    "fail_reasons": [
        "1. クレジットカードをご利用になるのが初めてで、有効化（アクティベーション）の手続きが完了していない可能性があります。",
        "2. クレジットカード番号または有効期限の入力に誤りがあります。",
        "3. クレジットカードの有効期限が切れています。",
        "4. ご利用可能枠を超えているか、ご利用残高が不足しています。",
        "5. カード発行会社のシステムで一時的に問題が発生しています。",
        "6. 同じカード番号で複数の決済処理が同時に行われています。",
        "7. カード認証中に通信が切断されました。",
        "8. カード会社の不正利用防止（リスク管理）基準に達しているため、決済を続行できません。"
    ],
    "how_to_fix": "ご利用可能枠を超えていない場合は、再度お試しください。カード番号、ご名義、有効期限、セキュリティコード（カード裏面の3桁の番号、アメリカン・エキスプレスは表面の4桁）が正しく入力されているかご確認ください。それでも決済が完了しない場合は、カード発行会社に詳細をお問い合わせください。",
    "got_it": "了解しました"
  },
  "ko":{
    "payment_success": "지불이 완료되었습니다",
    "payment_fail": "지불에 실패했습니다",
    "possible_reason": "원인이 있을 수 있습니다",
    "fail_reasons": [
        "1. 신용카드 첫 사용은 아직 카드가 발급되지 않았습니다",
        "2. 카드번호 또는 만기일이 잘못 입력되었습니다",
        "3. 신용카드는 이미 만기일 사용기한을 넘겼습니다",
        "4. 신용카드 사용 한도 초과 또는 잔액이 부족합니다",
        "5. 카드발급은행 내부시스템 문제입니다...등",
        "6. 이 카드 번호는 동시에 누군가가 카드를 사용하는 중이기 때문에 윈도우에서 튀어나올 것입니다",
        "7. 신용카드 인증 시 네트워크가 끊겼습니다",
        "8. 위험 제어 장치( credit)에 도달했기 때문에 더 이상 조작할 수 없습니다"
    ],
    "how_to_fix": "오류 유무를 다시 확인하시고, 다른 카드로 바꿔주시고, 다시 시도해 주세요. 만약 여전히 문제를 해결할 방법이 없다면,당신의 신용카드 발행 은행에 연락하여 협조를 요청해 주십시오.감사합니다.",
    "got_it": "알겠습니다"
  }
}
</i18n>
<template>
  <v-container column justify-space-between fill-height bg text-xs-center>
    <v-layout row wrap align-center>
      <v-flex v-if="success === undefined">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-flex>
      <v-flex v-else text-xs-left>
        <div v-if="success === true">
          <v-alert :value="true" type="success" outline>{{ $t('payment_success') }}</v-alert>
          <v-btn color="primary" block @click="$router.push({ name: 'home' })">OK</v-btn>
        </div>
        <div v-else>
          <v-alert :value="true" type="error" outline>
            <div>
              <div>{{ $t('payment_fail') }}</div>
              <br />
              <div>{{ $t('possible_reason') }}</div>
              <div>{{ $t('fail_reasons.0') }}</div>
              <div>{{ $t('fail_reasons.1') }}</div>
              <div>{{ $t('fail_reasons.2') }}</div>
              <div>{{ $t('fail_reasons.3') }}</div>
              <div>{{ $t('fail_reasons.4') }}</div>
              <div>{{ $t('fail_reasons.5') }}</div>
              <div>{{ $t('fail_reasons.6') }}</div>
              <div>{{ $t('fail_reasons.7') }}</div>
              <br />
              <div>{{ $t('how_to_fix') }}</div>
            </div>
          </v-alert>
          <v-btn color="primary" block @click="$router.push({ name: 'plan' })">{{ $t('got_it') }}</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/functions';
import { trackAbConvert } from '@/misc/ab';

export default {
  name: 'ecpay',
  data() {
    return {
      success: undefined,
    };
  },
  created() {
    const xGetPaymentsByUserId = firebase.functions().httpsCallable('XRobotmonGroup-xGetPaymentsByUserId');
    xGetPaymentsByUserId().then(result => {
      //   console.log(result);
      const payments = result.data.payments;
      if (!payments.length) {
        this.$router.push({ name: 'home' });
        return;
      }
      const data = payments[0];
      this.success = data.success;
      if (data.success) {
        // Last step of every landing-page A/B funnel.
        trackAbConvert('purchase', firebase.auth().currentUser);
      }
    });
  },
};
</script>
